import * as React from "react";
const SvgPlay = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.188 22.439q.337 0 .648-.13a4 4 0 0 0 .662-.324l14.417-8.376q.726-.402.998-.726.285-.336.285-.803 0-.454-.285-.778-.272-.338-.998-.752L6.498 2.187a4 4 0 0 0-.662-.324 1.7 1.7 0 0 0-.648-.13q-.649 0-1.024.454-.363.455-.363 1.206v17.386q0 .752.363 1.206.375.453 1.024.454"
  }
));
export default SvgPlay;
